import {
  cmsApiOnDepartureDateChangeSelector,
  cmsApiOnReturnDateChangeSelector,
  dateLabelSelector,
} from '../../selectors';
import { ThunkType } from 'app/hooks/appHooks';
import { setDepartureDate, setReturnDate } from 'app/store/reducers/date';
import { fromUnixTime } from 'date-fns';

export type SetDateType = { date: number; isReturn?: boolean };

export const setDate = ({ date, isReturn }: SetDateType): ThunkType<void> => {
  return (dispatch, getState) => {
    const state = getState();

    const onDepartureDateChanged = cmsApiOnDepartureDateChangeSelector(state);
    const onReturnDateChanged = cmsApiOnReturnDateChangeSelector(state);
    const dateLabel = dateLabelSelector(state);
    const dateLocalized = dateLabel(fromUnixTime(date));
    const payload = {
      date,
      dateLocalized,
    };

    const cmsMethod = isReturn ? onReturnDateChanged : onDepartureDateChanged;
    cmsMethod(payload);

    const method = isReturn ? setReturnDate : setDepartureDate;
    dispatch(method(payload));
  };
};
